import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

/**
 * Read-side hits menu-backend (Node/Mongo).
 * Review-side hits Java (`/menu-transactions/{mongoId}/review`) — those endpoints live
 * on the Java-membership base URL, so they use the default Dcore base query.
 */

const menuJavaBasePath = 'membership/menu-transactions'

const menuTransactionsEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
({
  // Fetch review states from Java for a page of Mongo transaction ids.
  lookupMenuTransactionReviews: builder.mutation<any, { ids: string[] }>({
    query: ({ ids }) => ({
      url: `${menuJavaBasePath}/reviews/lookup`,
      method: 'post',
      body: { ids },
    }),
  }),

  reviewMenuTransaction: builder.mutation<any, {
    mongoId: string;
    accountId: number;
    feeAmount?: number;
    amount: number;
    itemName?: string;
    txDate?: string;
  }>({
    query: ({ mongoId, accountId, feeAmount = 0, amount, itemName, txDate }) => ({
      url: `${menuJavaBasePath}/${mongoId}/review`,
      method: 'post',
      body: { accountId, feeAmount, amount, itemName, txDate },
    }),
    invalidatesTags: ['menu-tx-reviews', 'running-dashboard'],
  }),

  updateReviewedMenuTransaction: builder.mutation<any, {
    mongoId: string;
    accountId: number;
    feeAmount?: number;
  }>({
    query: ({ mongoId, accountId, feeAmount = 0 }) => ({
      url: `${menuJavaBasePath}/${mongoId}/review`,
      method: 'put',
      body: { accountId, feeAmount },
    }),
    invalidatesTags: ['menu-tx-reviews', 'running-dashboard'],
  }),
})

export default menuTransactionsEndpoints
